import styles from '../Logo.module.css'

export const JapanLogo = () => {
  return (
    <div className={styles[`Logo__japan-wrapper`]}>
      
      <svg className={styles.Logo__japan} viewBox="0 0 233.1 56.8">
        <path d="M11,0v18.2c11.9-2.8,23.2-7.6,32.4-13.1l5.4,9.6C38,21.2,25.4,26.2,11,29.4v12.3c0,3,1.7,4.5,5.1,4.5h34.4 L49,56.6H11.2c-4,0-6.9-0.9-8.8-2.7C0.8,52.1,0,49.2,0,45.1V0H11z M56.3,47.9h25v-19H63.4v-8.4h27.7V48h9.6v8.8H56.6L56.3,47.9 L56.3,47.9z M107,56.6V46h22.2V18.8h-17.6V8.1h46.7v10.5h-17.5V46H163v10.5C162.9,56.6,107,56.6,107,56.6z M181.8,19.3 c0,11.1-4.9,19.8-14.7,26.8l7.8,9.3c5.9-4,10.7-9.7,13.9-17.1C191.6,31.6,193,24,193,16V3.9h-11.2V19.3L181.8,19.3z M225.6,21.9 c-5.5,7.6-9.4,11.7-14.8,16.7V0h-11.5v49.3l7.1,8c10-7.6,18.9-16.1,26.7-25.7L225.6,21.9z" />
      </svg>
    </div>
  );
}
